export const isValidationError = (error: any) => {
  return error?.response?.status === 422;
};
